
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"12.358","height":"14.778","x":"2.821","y":"1.611","stroke":"#798f8f","rx":".5"}}),_c('mask',{staticClass:"i-path-2-inside-1_1434_46",attrs:{"fill":"#fff"}},[_c('rect',{attrs:{"width":"8.698","height":"8.039","x":"4.697","y":"6.464","rx":".5"}})]),_c('rect',{attrs:{"width":"8.698","height":"8.039","x":"4.697","y":"6.464","stroke":"#798f8f","stroke-width":"2","mask":"url(#path-2-inside-1_1434_46)","rx":".5"}})])
          )
        }
      }
    